export default __webpack_public_path__ + "static/IBMPlexSans-TextItalic-Latin2-62a3b11cc906d35cc5967dfaa506acf8.woff2";